'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	return function (session, instance) {
		if (!session) {
			console.warn('No session provided in service: Date Finder');
			return;
		}

		if (typeof instance === 'undefined') {
			console.warn('No instance provided in service: Date Finder');
			return;
		}

		var split = session.date.split('/');
		var year = +split[2];
		var month = +split[1] - 1;
		var day = +split[0];
		var sessionDate = new Date(year, month, day);

		return sessionDate.setDate(sessionDate.getDate() + session.frequency * instance);
	};
};


// WEBPACK FOOTER //
// ./client/components/misc-services/date-finder.js